import React, { Component } from 'react';

class Transaction extends Component {
    constructor(props) {
        super(props);
        this.intl = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
        let date = new Date(this.props.tr.date);
        this.dateString = date.toLocaleDateString();
    }

    render() {
        return (
            <tr>
                <td>{this.dateString}</td>
                <td>{this.props.tr.reference}</td>

                <td
                    style={{ color: this.props.tr.amount >= 0 ? 'green' : 'red' }}>
                    {this.props.tr.amount >= 0 ? "+" : ""}
                    {this.intl.format(this.props.tr.amount)}
                </td>
                <td>
                    <p>{this.intl.format(this.props.tr.balance)}</p>
                </td>
            </tr>
        );
    }
}

export default Transaction;


// WEBPACK FOOTER //
// ./src/Components/Ledger/Transaction.js